export default __webpack_public_path__ + "static/media/video.81ec9368.svg";